<!--This page will show when the entered url is invalid -->
<!-- for better understanding about  this have a look on router.js file -->
<template>
    <div class="NotFound pb-5">
        <div class="col-lg-6 mx-auto text-center">
            <img src="../assets/PageNotFound.png" alt="Not Found" class="col-8">
            <h1 class="proximanova-bold mt-4 fontsize30">The Requested URL is not found</h1>
            <button class="proximanova-semibold bordernone backgroundcolor3 borderradius20 fontsize18 p-1 pl-4 pr-4 white mt-4" @click="goToHome">Go to Home</button>
        </div>
        
    </div>
</template>

<script>
import router from '../router.js'
export default{
    name: 'NotFound',
    methods : {
        goToHome(){
            router.push({
                name : 'MainHome'
            })
        }
    }
}
</script>
<style scoped>
.NotFound{
    height: 100vh;
    padding-top: 8%;
}
@media screen and (max-width : 1000px) {
    .NotFound{
        padding-top: 20%;
    }
}
</style>